import { AI_SCHEDULES_PATH } from "@/constants";
import { SimpleButton } from "./SimpleButton";

export function AISchedulesButton({ isActive }: { isActive: boolean }) {
  return (
    <SimpleButton
      icon="Schedules"
      label="AI Schedules"
      href={AI_SCHEDULES_PATH}
      isActive={isActive}
    />
  );
}
